import { forwardRef } from 'react';
import styled from 'styled-components';
import { FormControlLabel, FormControlLabelProps } from '@mui/material';
import Radio from '../Radio/Radio';
import { radius, space } from '../../style/utils';

const FormControlLabelStyled = styled(FormControlLabel)<{
  $selected?: boolean;
}>`
  gap: ${space('xxl')};
  background: ${({ theme, $selected }) =>
    $selected ? theme.palette.surface.selected : theme.palette.surface.base};
  transition: background-color 150ms ease-in-out;
  border-radius: ${radius('lg')};
  padding: ${space('lg', 'xxl')};
  margin: 0;
  &:hover {
    background: ${({ theme }) => theme.palette.surface.selected};
  }
`;

type Props = Omit<FormControlLabelProps, 'control'> & {
  selected: boolean;
};

const LabeledRadioFormField = forwardRef(
  ({ selected, ...props }: Props, ref: any) => (
    <FormControlLabelStyled
      ref={ref}
      $selected={selected}
      control={<Radio />}
      {...props}
    />
  ),
);

export default LabeledRadioFormField;
